import React, { useEffect, useRef } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { areEqual } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { FixedSizeList as List } from "react-window";
import { useRecoilState, useRecoilValue } from "recoil";
import { currentColorTableSel } from "../../recoil/coloreditor/selectors";
import EditableListItem from "./EditableListItem";
import { reorder } from "../../utils";
import { colorDbState, scrollToViewIndRow, selColorRowsState, selTableIDState } from "../../recoil/coloreditor/atoms";
import classNames from "classnames";

function getStyle(provided, style) {
  if (!style) {
    return provided.draggableProps.style;
  }

  return {
    ...provided.draggableProps.style,
    ...style,
  };
}
const ColorItem = (props) => {
  const { colorRow, isDragging, isGroupedOver, provided, style, isClone, index, selectionLength } = props;
  return (
    <div
      ref={provided.innerRef}
      {...provided.draggableProps}
      style={getStyle(provided, style)}
      data-is-dragging={isDragging}
      data-testid={colorRow.FlatColor}
      data-index={index}
      className={classNames("draggable-color-row", { "draggable-color-row--dragging": isDragging })}
    >
      <EditableListItem dragHandleProps={provided.dragHandleProps} colorRow={colorRow} colorIndex={index} />
      {selectionLength ? <div className="draggable-color-row__number-tag">{selectionLength}</div> : <></>}
    </div>
  );
};
const Row = React.memo(({ data: colorRows, index, style }) => {
  const colorRow = colorRows[index];
  return (
    <Draggable draggableId={colorRow.FlatColor} index={index} key={colorRow.FlatColor}>
      {(provided, snapshot) => (
        <ColorItem
          provided={provided}
          colorRow={colorRow}
          isDragging={snapshot.isDragging}
          isGroupedOver={Boolean(snapshot.combineTargetFor)}
          style={{ margin: 0, ...style }}
          index={index}
        />
      )}
    </Draggable>
  );
}, areEqual);

const ColorRows = () => {
  const currentColorTable = useRecoilValue(currentColorTableSel);
  const [colorTables, setColorTables] = useRecoilState(colorDbState);
  const selTableId = useRecoilValue(selTableIDState);
  const [selColRows, setSelColRows] = useRecoilState(selColorRowsState);
  const scrollInd = useRecoilValue(scrollToViewIndRow);
  const ref = useRef();
  useEffect(() => {
    // console.log(ref, scrollInd);
    // if (!scrollInd || !ref.current) return;
    //   ref.current.scrollToItem(scrollInd);
    // const timeout = setTimeout(() => {
    //   ref.current.scrollToItem(scrollInd);
    //   console.log("timeout -> scrollInd", scrollInd);
    // }, 200);
    // return () => {
    //   clearTimeout(timeout);
    // };
  }, [scrollInd]);
  const onDragEnd = (result) => {
    if (!result.destination) return;
    if (result.source.index === result.destination.index) return;

    const newColorRows = reorder(
      currentColorTable.ColorRows,
      result.source.index,
      result.destination.index,
      selColRows
    );
    const colorTableNew = { ...currentColorTable, ColorRows: newColorRows };
    const colorTablesTemp = colorTables.slice();
    colorTablesTemp.splice(selTableId, 1, colorTableNew);
    setColorTables(colorTablesTemp);
    setSelColRows([]);
  };
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable
        droppableId="droppable"
        mode="virtual"
        renderClone={(provided, snapshot, rubric) => (
          <ColorItem
            selectionLength={selColRows.length}
            colorRow={currentColorTable.ColorRows[rubric.source.index]}
            provided={provided}
            isDragging={snapshot.isDragging}
            style={{ margin: 0 }}
            index={rubric.source.index}
          />
        )}
      >
        {(droppableProvided) => (
          <AutoSizer disableWidth>
            {({ height, width }) => (
              <List
                height={height}
                itemCount={currentColorTable.ColorRows.length}
                itemSize={40}
                width="100%"
                ref={ref}
                outerRef={droppableProvided.innerRef}
                itemData={currentColorTable.ColorRows}
              >
                {Row}
              </List>
            )}
          </AutoSizer>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default ColorRows;
